'use client';
import LandingPage from '@/components/LandingPage';


export default function DashboardPage() {

  return (
    <div className="space-y-6  ">
      {/* 헤더 */}
       {/* DashboardPage /home/issac/_project/smart-farm/ifms/ifms-frontend_v1.0.0/src/app/(dashboard)/page.tsx */}
           <LandingPage />;
    </div>
  );
}
